import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';

class Ago extends React.PureComponent {
  render() {
    return (
      <span className={this.props.className}>
        <i className="fa fa-calendar-o pr-5" />
        {moment(this.props.time)
          .locale('es')
          .fromNow()
        }
      </span>
    );
  }
}

Ago.propTypes = {
  className: PropTypes.string,
  time: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
  ]),
};

Ago.defaultProps = {
  time: undefined,
  className: '',
};

export default Ago;



// WEBPACK FOOTER //
// ./src/components/Ago/index.js